<div class="element-wrapper" [ngStyle]="wrapperStyles">
  @if (labelEnabled) {
    <blaze-element-header
      [color]="props?.style?.label?.color?.color1"
      [fontFamily]="props?.style?.titleBlock?.fontFamily"
      [fontSize]="props?.style?.titleBlock?.fontSize"
      [fontStyle]="props?.style?.titleBlock?.fontStyle"
      [fontWeight]="props?.style?.titleBlock?.fontWeight"
      [horizontalAlign]="props?.content?.title?.align"
      [icon]="props?.content?.title?.icon"
      [iconColor]="props?.content?.title?.iconColor?.color1"
      [iconPosition]="props?.content?.title?.iconPosition"
      [iconSize]="props?.style?.titleBlock?.iconSize"
      class="mb-16"
    >
      {{ label }}
    </blaze-element-header>
  }
  <div class="iframe-border" [ngStyle]="iframeBorderStyles">
    @if (isInEditor && hasUrl && isValidUrl) {
      <div class="overlay">
        <div class="overlay-info rounded-8">IN EDIT MODE PAGE ISN'T CLICKABLE</div>
      </div>
    }
    @if (hasUrl && isInEditor && !isValidUrl) {
      <div class="overlay always-visible">
        <div class="overlay-info rounded-8">PLEASE CONFIGURE PROPER WEBSITE URL</div>
      </div>
    }
    @if (!hasUrl && isInEditor) {
      <div class="placeholder">
        <p>To see the page, configure page URL in the properties panel.</p>
        <p
          >Please ensure the target page is properly configured to be displayed inside other
          pages.</p
        >
      </div>
    }
    @if (hasUrl) {
      <iframe class="iframe" [ngStyle]="iframeStyles" [src]="iframeSrc()"></iframe>
    }
  </div>
</div>
